import { DeleteOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';
import { useTranslation } from '@framework/i18n';
import { Radio } from 'antd';
import * as React from 'react';
import { MapDrawingRadioButton } from './radio-button/MapDrawingRadioButton';

export interface IMapDrawingControlsProps {
  onModeChange: (mode: 'view' | 'draw' | 'delete') => void;
  mode: 'view' | 'draw' | 'delete';

  isMobile?: boolean | null;
}

export function MapDrawingControls(props: IMapDrawingControlsProps) {
  const { onModeChange, mode, isMobile } = props;
  const { t } = useTranslation();

  return (
    <div>
      <Radio.Group
        buttonStyle="solid"
        onChange={e => {
          onModeChange(e.target.value ?? 'view');
        }}
        value={mode}
      >
        <MapDrawingRadioButton
          isMobile={isMobile}
          label={t('mappa.controlli.visualizza', {
            defaultValue: 'Visualizza',
          })}
          value="view"
          icon={<EyeOutlined aria-hidden="true" />}
        />
        <MapDrawingRadioButton
          isMobile={isMobile}
          label={t('mappa.controlli.disegna', {
            defaultValue: 'Disegna',
          })}
          value="draw"
          icon={<EditOutlined aria-hidden="true" />}
        />
        <MapDrawingRadioButton
          isMobile={isMobile}
          label={t('mappa.controlli.elimina', {
            defaultValue: 'Elimina',
          })}
          value="delete"
          icon={<DeleteOutlined aria-hidden="true" />}
        />
      </Radio.Group>
    </div>
  );
}
